"use strict";

var _screeners = require("../../screeners");

var utils = require("../../screeners/utils");

var surveyscreeners = [utils.screeners.WHO5, utils.screeners.ALLIANZ_STRESS, utils.screeners.ALLIANZ_PROGRESS];
var questions = (0, _screeners.expandscreeners)([].concat(surveyscreeners));

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    var answer;
    if (screener === "ALLIANZ_STRESS") answer = answers["STRESS"] || answers["ALLIANZ_STRESS"];else answer = answers[screener];
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answer, screener); // answer: {WHO5: Array, STRESS: Array}
    // filteredQuestions.forEach(function (q, i) {
    // 	if (!q.key) return
    // 	results[q.key] = q.eval(answer[i])
    // })
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};